<template>
  <div class="stepper-wrapper">
    <div :class="{ 'stepper-item completed': true }">
      <div class="step-counter">
        <font-awesome-icon :icon="['fas', 'check']" />
      </div>
      <div class="step-name">{{ setName("RESERVADO") }}</div>
    </div>
    <div
      v-if="customerId !== 146"
      :class="{
        'stepper-item': true,
        completed: [
          'PROMESADO',
          'ESCRITURADO',
          'ENTREGADO',
          'POSTVENTA',
        ].includes(apartment.asset_state),
      }"
    >
      <div class="step-counter">
        <font-awesome-icon
          v-if="
            ['PROMESADO', 'ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
              apartment.asset_state
            )
          "
          :icon="['fas', 'check']"
        />
        <font-awesome-icon
          v-else-if="['RESERVADO'].includes(apartment.asset_state)"
          :icon="['far', 'hourglass']"
          class="fa-spin"
          style="--fa-animation-iteration-count: 5"
        />
        <template v-else-if="country == 1">2</template>
      </div>
      <div class="step-name">{{ setName("PROMESADO") }}</div>
    </div>
    <div
      v-if="country == 1"
      :class="{
        'stepper-item': true,
        completed: ['ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
          apartment.asset_state
        ),
      }"
    >
      <div class="step-counter">
        <font-awesome-icon
          v-if="
            ['ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
              apartment.asset_state
            )
          "
          :icon="['fas', 'check']"
        />
        <font-awesome-icon
          v-else-if="['PROMESADO'].includes(apartment.asset_state)"
          :icon="['far', 'hourglass']"
          class="fa-spin"
          style="--fa-animation-iteration-count: 5"
        />
        <template v-else-if="country == 1">3</template>
      </div>
      <div class="step-name">{{ setName("ESCRITURADO") }}</div>
    </div>
    <div
      :class="{
        'stepper-item': true,
        completed: ['ENTREGADO', 'POSTVENTA'].includes(apartment.asset_state),
      }"
    >
      <div class="step-counter">
        <font-awesome-icon
          v-if="['ENTREGADO', 'POSTVENTA'].includes(apartment.asset_state)"
          :icon="['fas', 'check']"
        />
        <font-awesome-icon
          v-else-if="
            (country == 1
              ? ['ENTREGADO']
              : ['PROMESADO', 'ENTREGADO']
            ).includes(apartment.asset_state)
          "
          :icon="['far', 'hourglass']"
          class="fa-spin"
          style="--fa-animation-iteration-count: 5"
        />
        <template v-else-if="country == 1">4</template>
      </div>
      <div class="step-name">{{ setName("ENTREGADO") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BuyProgress",
  props: {
    apartment: { default: null },
    country: { default: 1 },
  },
  methods: {
    setName(name) {
      switch (name) {
        case "RESERVADO":
          return this.country == 1 ? "Reservado" : "Separado";
        case "PROMESADO":
          return this.country == 1 ? "Promesado" : "Minuta";
        case "ESCRITURADO":
          return this.country == 1 ? "Escriturado" : "Escriturado";
        case "ENTREGADO":
          return this.country == 1 ? "Entregado" : "Entregado";
      }
    },
  },
  computed: {
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : null;
    },
  },
};
</script>
<style></style>
